export default "__VITE_ASSET__DHVkxOTl__"